import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/Navbar.css";
import LogoSVG from "./LogoSVG";

const PHONE_NUMBER = "+386040942579";

/**
 * Navbar renders a simple navigation bar with links to the
 * homepage, services page and blog. NavLink is used to apply
 * an active class to the link corresponding to the current route.
 */
const Navbar = () => {
  const [open, setOpen] = useState(false);

  const showAdmin = process.env.REACT_APP_SHOW_ADMIN === "true";
  // Admin link intentionally hidden by default; only show when explicitly enabled via env.
  const showAdminLink = showAdmin;

  return (
    <nav className="navbar">
      <div className="nav-left">
        <button
          className="nav-toggle"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <span className="hamburger" />
        </button>
        <NavLink to="/" className="brand">
          <LogoSVG height={52} className="brand-logo" />
        </NavLink>
      </div>

      {open && <div className="nav-overlay" onClick={() => setOpen(false)} />}

      <ul
        className={`nav-links ${open ? "open" : ""}`}
        onClick={() => setOpen(false)}
      >
        <li className="mobile-menu-logo">
          <NavLink to="/" className="mobile-brand">
            <LogoSVG height={48} className="mobile-brand-logo" />
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Domov
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            O&nbsp;meni
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/services"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Storitve
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/blog"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Blog
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/booking"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Rezervacije
          </NavLink>
        </li>
        {showAdminLink && (
          <li>
            <NavLink
              to="/admin"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              Admin
            </NavLink>
          </li>
        )}
        <li className="nav-phone">
          <a
            href={`tel:${PHONE_NUMBER}`}
            aria-label="Pokličite nas na 040 942 579"
          >
            040 942 579
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
